import React from "react";
import { Link } from "react-router-dom";
import EssenceActionsDropdown from "../../Essence/EssenceActionsDropdown";
import EssenceStateLabel from "../../Essence/EssenceStateLabel";

export default function CertificateListItem(props) {
  const validtodate = props.validtodate ? new Date(props.validtodate) : {};
  const validfromdate = props.validfromdate
    ? new Date(props.validfromdate)
    : {};
  const issueddate = props.issueddate ? new Date(props.issueddate) : {};
  const rights = props.rights || {};

  let daysValid = 0;
  if (props.validtodate) {
    let dt = new Date();
    daysValid = Math.round((validtodate - dt) / (1000 * 60 * 60 * 24));
  }

  return (
    <>
      <div
        className={`d-flex justify-content-between align-items-center py-4  border-bottom text-dark`}
      >
        <div style={{ wordBreak: "break-all" }} className="m-lg-0 flex-grow-1">
          <div className="row">
            <div className="col-lg-8">
              <Link
                className={`mb-1 text-hover-primary ${
                  daysValid < 60 ? "text-dark" : "text-dark "
                }`}
                to={`/certificate/${props.ship}/${props.id}/`}
              >
                <i className="fa fa-file-o mr-2"></i>
                {props.label || props.identity}
              </Link>
              <div>
                {props.description && (
                  <span className="font-italic text-dark-50">
                    {props.description}
                  </span>
                )}
              </div>
              {props.shipname && (
                <div className="mt-1 small text-muted">{props.shipname}</div>
              )}
            </div>
            <div className="col-lg">
              {props.identity && (
                <div className="mt-1 text-dark-50">{props.identity}</div>
              )}
              {props.issueddate && (
                <div className="text-dark-75" title="Дата выпуска">
                  <span className="small text-muted w-30px  d-inline-block">
                    выд.
                  </span>
                  {issueddate.toLocaleDateString()}
                </div>
              )}
            </div>
            <div className="col-lg">
              {props.validfromdate && (
                <div className="text-dark-75" title="Действителен от">
                  <span className="small text-muted w-20px  d-inline-block">
                    с
                  </span>
                  {validfromdate.toLocaleDateString()}
                </div>
              )}

              {props.validtodate && (
                <>
                  <div
                    className={`${
                      daysValid < 60 ? "text-fail" : "text-dark-75"
                    }`}
                    title="Действителен до"
                  >
                    <span className="small text-muted w-20px d-inline-block">
                      по
                    </span>
                    {validtodate.toLocaleDateString()}
                  </div>
                  {daysValid < 60 && (
                    <label className="label label-inline bg-light-danger">
                      {daysValid} дн.
                    </label>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
        <div>
          <div className="d-flex align-items-center justify-content-end text-right">
            <EssenceStateLabel
              stateCode={props.statetypecode}
              stateLabel={props.statelabel}
              essence="certificate"
              id={props.id}
            />
            {rights.manage && (
              <EssenceActionsDropdown
                essence={"certificate"}
                key={props.id}
                id={props.id}
                label={props.label}
                onFinish={props.onFinish}
              />
            )}
            {rights.manage && (
              <button
                onClick={() => props.onEditClick(props)}
                className="btn btn-icon btn-light ml-2"
              >
                <i className="fa fa-pencil"></i>
              </button>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
